export { default } from "./Coin";
